module.exports = __webpack_public_path__ + "img/nota-cinvestav.0c419a79.jpg";